import React from 'react'

import { BulletinType } from '../../../common/validations'
import { BulletinFeaturedImage } from './components/BulletinFeaturedImage/BulletinFeaturedImage'
import { BulletinTitle } from './components/BulletinTitle/BulletinTitle'
import { BulletinDetails } from './components/BulletinDetails/BulletinDetails'
import { BulletinWrapper } from './components/BulletinWrapper/BulletinWrapper'
import { BulletinBody } from './components/BulletinBody/BulletinBody'
import { BulletinAttachments } from './components/BulletinAttachments/BulletinAttachments'

interface BulletinProps {
  bulletin: BulletinType
  onLanguageChange: (language: BulletinType['language']) => void
}

export const Bulletin: React.FC<BulletinProps> = ({
  bulletin: {
    title,
    publishedAt,
    updatedAt,
    author,
    featuredImage,
    body,
    attachments,
    language,
    availableLanguages,
  },
  onLanguageChange,
}) => {
  return (
    <BulletinWrapper>
      <BulletinTitle
        title={title}
        language={language}
        availableLanguages={availableLanguages}
        onLanguageChange={onLanguageChange}
      />

      <BulletinDetails
        publishedAt={publishedAt}
        updatedAt={updatedAt}
        author={author}
      />

      {featuredImage && <BulletinFeaturedImage featuredImage={featuredImage} />}

      <BulletinBody body={body} language={language} />

      <BulletinAttachments attachments={attachments} />
    </BulletinWrapper>
  )
}
